import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const EmbedRouteLoader: LoadableType<{
	contentId: string;
	spaceKey: string;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EmbedContainer" */ './EmbedContainer.tsx'))
			.EmbedContainer,
});
